export const strings = {
  title: 'ログイン',
  description: 'root C Dashboard',
}
